module.exports = __webpack_public_path__ + "static/media/chess-board.530859df.svg";